export const CheckmarkCircleOut = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1_6265)">
<path d="M9.94604 15.4095L14.0845 19.548L29.1325 4.5" stroke="currentColor" stroke-width="2"/>
<path d="M28.354 11.9531C29.2958 14.8279 29.2055 17.9411 28.0986 20.7565C26.9918 23.5719 24.9377 25.9132 22.2903 27.3769C19.6429 28.8407 16.5678 29.3353 13.5949 28.7757C10.622 28.216 7.93731 26.637 6.00339 24.3107C4.06947 21.9845 3.00738 19.0566 3.00008 16.0314C2.99278 13.0063 4.04073 10.0733 5.96341 7.73776C7.88608 5.4022 10.5631 3.81029 13.5333 3.23627C16.5035 2.66224 19.5809 3.14205 22.2353 4.59302" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
</g>
<defs>
<clipPath id="clip0_1_6265">
<rect width="32" height="32" fill="white"/>
</clipPath>
</defs>
</svg>`;
